







import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Post } from '@/business/post/models/post'
import { PostUpdate } from '@/business/post/models/post-update'

@Component({
  name: 'post-replies',
  components: {
    RespondecoPost: () => import('@/business/post/components/post/post.vue'),
  },
})
export default class PostReplies extends Vue {
  @Prop({
    type: Object,
  })
  public readonly post?: Post

  @Prop({
    type: Function,
  })
  public readonly updatePost!: (post: PostUpdate) => Promise<Post>

  public get hasReplies(): boolean {
    let hasReplies = false

    if (this.post !== undefined) {
      hasReplies = this.post.replies.length > 0
    }

    return hasReplies
  }
}
